import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/EditOutlined';
import BaseDialog from '../BaseDialog/BaseDialog';
import ReplaceTermsOfUse from '../Replace/ReplaceTermsOfUse/ReplaceTermsOfUse';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ConfirmationTermsDialog extends React.Component {
  field(label, value) {
    const { classes } = this.props;

    if (value) {
      return (
        <div className={classes.field}>
          <Typography className={classes.label}>{label}</Typography>
          <Typography>{value}</Typography>
        </div>
      );
    }
  }

  render() {
    const { classes, open, cancel, confirm } = this.props;

    const stringsComponent = 'confirmationTermsDialog';

    return (
      <div className={classes.root}>
        <BaseDialog
          open={open}
          content={
            <React.Fragment>
              <Typography className={classes.dialogText}>
                <ReplaceTermsOfUse
                  content={getString(stringsComponent, 'CONFIRM_TEXT')}
                  linkUrl={portalContent.APP_BANK_DETAILS_LINK}
                />
              </Typography>
            </React.Fragment>
          }
          contentWrap={false}
          title={getString(stringsComponent, 'CONFIRM_TITLE')}
          buttonAction={confirm}
          buttonLabel={getString(stringsComponent, 'SUBMIT_BUTTON_LABEL')}
          secondaryButtonAction={cancel}
          secondaryButtonLabel={getString(
            stringsComponent,
            'CANCEL_BUTTON_LABEL'
          )}
          icon={EditIcon}
        />
      </div>
    );
  }
}

ConfirmationTermsDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
};

ConfirmationTermsDialog.defaultProps = {
  open: false,
};

export default withStyles(styles)(ConfirmationTermsDialog);
